var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436 368.236V400H76v-31.764h44.646V179.412H76.708L256 40l179.291 139.412h-43.582v188.824H436Z",
    fill: "#36F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.783,
    cy: 261.229,
    rx: 107.92,
    ry: 107.497,
    fill: "#C8DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.593 291.632 18.426 10.757-7.073 12.234-18.613-10.567 3.536 21.502-13.958 2.224-5.399-32.995-14.518-8.344 3.537 32.071-26.056-19.095v16.686l25.871 21.135-8.934 10.936-16.937-13.717v21.319h-14.332v-21.319l-16.935 13.717-9.121-10.936 26.056-21.135v-16.686l-26.056 19.095 3.537-32.071-14.518 8.344-5.397 32.995-14.145-2.224 3.537-21.502-18.426 10.567-7.26-12.234 18.613-10.757-20.474-7.596 5.025-13.349 31.455 11.861 14.33-8.339-29.592-12.98 29.592-12.975-14.33-8.344-31.455 11.866-5.025-13.348 20.474-7.603-18.613-10.751 7.26-12.234 18.426 10.567-3.537-21.508 14.146-2.223 5.397 33 14.517 8.339-3.537-32.071 26.056 19.095v-16.687l-26.056-21.129 9.121-10.941 16.935 13.717V166.68h14.332v21.318l16.938-13.716 8.933 10.94-25.871 21.13v16.687l26.056-19.095-3.537 32.07 14.518-8.338 5.399-33.001 13.958 2.224-3.536 21.508 18.613-10.567 7.073 12.234-18.426 10.751 20.286 7.602-5.025 13.349-31.27-11.866-14.517 8.343 29.594 12.975-29.594 12.981 14.517 8.338 31.27-11.86 5.025 13.348-20.286 7.597Zm-51.741-3.522-2.048-19.095 17.494-7.786-17.494-7.787 2.048-19.094-15.636 11.492-15.447-11.492 2.048 19.094-17.682 7.787 17.682 7.786-2.048 19.095 15.447-11.493 15.636 11.493Z",
    fill: "#36F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412 512c55.228 0 100-44.772 100-100s-44.772-100-100-100-100 44.772-100 100 44.772 100 100 100Z",
    fill: "#90BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.452 348.889c-19.786 0-36.146 9.167-41.447 13.595-10.977-9.357-23.563-12.163-37.145-12.163-13.099 0-23.722 3.183-32.484 13.291v97.518c0 1.838 1.295 3.884 3.89 6.141 2.594 2.257 4.95 3.385 7.062 3.385.768 0 1.443-.211 2.021-.629l7.915-8.285c5.423-6.411 12.989-7.121 19.331-7.121 7.216 0 15.761 7.45 25.63 19.213 1.566 1.864 11.286 1.636 12.697-.354 8.407-11.854 12.266-20.056 18.768-20.056 6.821 0 16.715.621 26.383 16.478.767 1.256 3.121.754 4.757.754 7.304 0 10.96-4.849 10.96-14.541v-90.623c-1.16-6.016-15.147-16.603-28.338-16.603Zm-44.816 96.161c-5.685-5.181-17.05-10.244-25.524-10.244-8.379 0-21.891 3.798-29.212 8.976v-77.387c5.009-4.182 15.97-6.842 21.559-6.842 7.026 0 24.727 1.695 33.237 16.267l-.06 69.23Zm62.093-1.268c-7.321-5.178-20.835-8.976-29.213-8.976-8.473 0-19.838 5.063-25.523 10.244l.604-69.23c8.507-14.572 25.55-16.267 32.576-16.267 5.586 0 16.547 2.66 21.556 6.842v77.387Z",
    fill: "#36F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(312 312)",
    d: "M0 0h200v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLib);
export default __webpack_public_path__ + "static/media/lib.b2498b40dc88a74eff3f1157852fab49.svg";
export { ForwardRef as ReactComponent };